import { WORKOUT_KEY } from '../../../../../modules/workout/model/constants/key'
import updateWorkoutAction from '../update'
import WORKOUTS_ACTION from '../../constants/action'

function updateDifficultyWorkoutAction (value) {
  return updateWorkoutAction({
    type: WORKOUTS_ACTION.UPDATE_DIFFICULTY,
    payload: {
      key: WORKOUT_KEY.DIFFICULTY,
      value
    }
  })
}

export default updateDifficultyWorkoutAction
